/*eslint-disable*/
import request from '@/api/request'
import store from '@/store'

// 修改Api Url方法
export function RequestBase(params) {
  const api_url = store ? store.getters.api_url : process.env.BASE_API
  return request({
    baseURL: api_url,
    ...params
  })
}


// WEBPACK FOOTER //
// ./src/api/base.js